import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import SidebarField from "../../../../Components/SidebarField";
import Button from "../../../../Components/Button";
import TextInput from "../../../../Components/TextInput";
import SelectDropDown from "../../../../Components/Dropdown/SelectDropdown";
import { FormField } from "../../../../Components/FormField";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import { RegionMasterApi } from "../../../../App/api/RegionMaster";
import { MasterApi } from "../../../../App/api/setting";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import DeliveryFeeValidationSchema from './DeliveryFeeValidationSchema';
import { DeliveryApi } from "../../../../App/api/DeliveryFee.apis";
import { toast } from "react-toastify";

function AddDeliveryFee({ open, handleClose, currentItems, onSuccess }) {
 
  const [factorField, setFactorField] = useState(null);
  const [regionId, setRegionId] = useState(null);
  const [isRegionDetail, setIsRegionDetail] = useState(false);
  const [isDeliveryType, setIsDeliveryType] = useState(currentItems?.deliveryType?._id || null);

  // console.log("currentItems",currentItems);
  

    const deliveryTypeOptions = [
    { name: "Bike", _id: "bike" },
    { name: "Van", _id: "van" },
    { name: "Truck", _id: "truck" },
    { name: "Any", _id: "any" },
  ];

  useEffect(() => {
    if (currentItems) {
      setRegionId(currentItems.regionType?._id);
      setIsDeliveryType(currentItems.deliveryType?._id);
    }
  }, [currentItems]);
  

  // Fetch region and delivery data
  const regionData = useFetchAll(() => RegionMasterApi.getAllRegionData());
  const deliveryData = useFetchAll(() =>
    MasterApi.master.getAllDeliveryTypeData()
  );

  const regionOption = regionData.value?.data || [];
  const DeliveryOption = deliveryData.value?.data || [];

  // Find the selected region and delivery type
  const filteredRegion = regionOption.find((region) => region._id === regionId);
  const filteredDelivery = DeliveryOption.find((delivery) => delivery._id === isDeliveryType);

  const initialValues = {
    deliveryType: currentItems?.deliveryType?._id || "",
    vehicleType:
      currentItems?.vehicleType?._id || currentItems?.vehicleType || "",
    regionType: currentItems?.regionType?._id || "",
    additionalFee: currentItems?.additionalFee || 0.0,
    referralFeeRate: currentItems?.referralFeeRate || 0.0,
    closingFeeRate: currentItems?.closingFeeRate || 0.0,
    shippingFeeRate: currentItems?.shippingFeeRate || 0.0,
    shippingHandlingFeeFixedRate:
      currentItems?.shippingHandlingFeeFixedRate || 0.0,
    factors: currentItems?.factor?.map((d) => d._id) || [],
    factor: currentItems?.factor || [],
  };
  const handleSubmit = async (values, { resetForm }) => {
    // console.log("values", values);
    // console.log("values", values);
    try {
      const res = currentItems?._id
        ? await DeliveryApi.updateDeliveryFee(values,currentItems?._id)
        : await DeliveryApi.createDeliveryFee(values);
      onSuccess && onSuccess();
      // console.log("response", res);
      toast.success("Delivery Fee saved successfully");
      handleClose(); 
    } catch (err) {
      console.error(err);
      toast.error(err?.message);
    } finally  {
      
      resetForm(); 
      setRegionId(null); 
      setIsDeliveryType(null); 
    }
  };

  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
          validationSchema={DeliveryFeeValidationSchema}
        >
          {({
            handleChange,
            values,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={
                  currentItems?._id
                    ? `Update Delivery Fee`
                    : `Add New Delivery Fee`
                }
                button1={
                  <Button text="Cancel" type="button" onClick={handleClose} />
                }
                button2={
                  <Button
                    text={currentItems?._id ? "Update" : "Submit"}
                    type="submit" 
                  />
                }
              >
                {/* Region Type Dropdown */}
                <FormField label="Region Type" tooltip="Select Region Type">
                <div  className="card flex justify-content-center">
                    <Dropdown  
                        
                        value={values.regionType}
                        onChange={(e) => 
                          {
                            const v=e.value
                            setFieldValue("regionType", v); 
                            // console.log("region type value:", v);
                            setRegionId(v); 
                            const selectedRegion = regionOption.find(
                              (region) => region._id === v
                            );
                            
                            if (selectedRegion) {
                              setFieldValue(
                                "additionalFee",
                                selectedRegion.additionalFee || 0.0
                              );
                              setFieldValue(
                                "referralFeeRate",
                                selectedRegion.referralFeeRate || 0.0
                              );
                              setFieldValue(
                                "closingFeeRate",
                                selectedRegion.closingFeeRate || 0.0
                              );
                              setFieldValue(
                                "shippingFeeRate",
                                selectedRegion.shippingFeeRate || 0.0
                              );
                              setFieldValue(
                                "shippingHandlingFeeFixedRate",
                                selectedRegion.shippingHandlingFeeFixedRate || 0.0
                              );
                            }
                            
                            else {
                              // console.log("No region found for ID:", v);
                            }
                          }
                        } 
                        options={ regionOption || []} 
                        optionLabel={`regionType`} 
                        optionValue={`_id`}
                        placeholder={`Region Type`} 
                        className="w-full rounded-[5px] h-[2.6rem]"
                        // filter valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate} className="w-full  md:w-10rem"                 
                    />
                   
                </div> 
                  <ErrorMessage
                    name="regionType"
                    component="p"
                    className="error"
                  />
                </FormField>

                {/* Delivery Type Dropdown */}
                <FormField label="Delivery Type" tooltip="Select Delivery Type">
                  <SelectDropDown
                    sx={{ borderRadius: "3px", height: "2.6rem" }}
                    value={values.deliveryType}
                    inputName="deliveryType"
                    placeholder="Select Delivery Type"
                    options={DeliveryOption}
                    optionLabel="name"
                    optionValue="_id"
                    handleFilter={(name, v) => {
                      setFieldValue("deliveryType", v);
                      // console.log("delivery Type:", v);
                      setIsDeliveryType(v);
                    }}
                  />
                  <ErrorMessage
                    name="deliveryType"
                    component="p"
                    className="error"
                  />
                </FormField>
                {/* Delivery Type Dropdown */}
                <FormField label="Vehicle Type" tooltip="Select Delivery Type">
                  <SelectDropDown
                    sx={{ borderRadius: "3px", height: "2.6rem" }}
                    value={values.vehicleType}
                    inputName="vehicleType"
                    placeholder="Select Vehicle Type"
                    options={deliveryTypeOptions}
                    optionLabel="name"
                    optionValue="_id"
                    handleFilter={(name, v) => {
                      setFieldValue("vehicleType", v);
                    }}
                  />
                  <ErrorMessage
                    name="vehicleType"
                    component="p"
                    className="error"
                  />
                </FormField>

                {/* Additional Fields for Selected Region */}
                {filteredRegion && (
                  <>
                    {filteredRegion && (
                      <>
                        <FormField
                          label="Additional Fee"
                          tooltip="Enter additional fee"
                        >
                          <TextInput
                            name={"additionalFee"}
                            type={"number"}
                            placeholder={"Enter Additional Fee"}
                            onChange={handleChange}
                            value={values?.additionalFee}
                          />
                          <ErrorMessage
                            name="additionalFee"
                            component="p"
                            className="error"
                          />
                        </FormField>
                        <FormField
                          label="Referral Fee Rate"
                          tooltip="Enter referral fee rate"
                        >
                          <TextInput
                            name={"referralFeeRate"}
                            type={"number"}
                            placeholder={"Enter Referral Fee Rate"}
                            onChange={handleChange}
                            value={values?.referralFeeRate}
                          />
                          <ErrorMessage
                            name="referralFeeRate"
                            component="p"
                            className="error"
                          />
                        </FormField>
                        <FormField
                          label="Closing Fee Rate"
                          tooltip="Enter closing fee rate"
                        >
                          <TextInput
                            name={"closingFeeRate"}
                            type={"number"}
                            placeholder={"Enter Closing Fee Rate"}
                            onChange={handleChange}
                            value={values?.closingFeeRate}
                          />
                          <ErrorMessage
                            name="closingFeeRate"
                            component="p"
                            className="error"
                          />
                        </FormField>
                        <FormField
                          label="Shipping Fee Rate"
                          tooltip="Enter shipping fee rate"
                        >
                          <TextInput
                            name={"shippingFeeRate"}
                            type={"number"}
                            placeholder={"Enter Shipping Fee Rate"}
                            onChange={handleChange}
                            value={values?.shippingFeeRate}
                          />
                          <ErrorMessage
                            name="shippingFeeRate"
                            component="p"
                            className="error"
                          />
                        </FormField>
                        <FormField
                          label="Shipping Handling Fee Fixed Rate"
                          tooltip="Enter shipping handling fee fixed rate"
                        >
                          <TextInput
                            name={"shippingHandlingFeeFixedRate"}
                            type={"number"}
                            placeholder={
                              "Enter Shipping Handling Fee Fixed Rate"
                            }
                            onChange={handleChange}
                            value={values?.shippingHandlingFeeFixedRate}
                          />
                          <ErrorMessage
                            name="shippingHandlingFeeFixedRate"
                            component="p"
                            className="error"
                          />
                        </FormField>
                      </>
                    )}
                  </>
                )}

                {/* Factor Field based on Selected Delivery Type */}
                {(filteredDelivery || currentItems) &&(
                  <>
                  {/* {JSON.stringify(values.factors)}  */}
                    <FormField label="Factor" tooltip="Select factors">
                      {isDeliveryType === "67163525ee2aa9964c01f308" ? (
                        <SelectDropDown
                          sx={{ borderRadius: "3px", height: "2.6rem" }}
                          name="factor"
                          value={values.factors}
                          options={filteredDelivery?.factor || []}
                          placeholder="Select a factor"
                          handleFilter={(name, selectedOption) => {
                           
                            const selectedData = filteredDelivery?.factor.find(
                              (option) => option._id === selectedOption
                            );
                            // setFactorField([selectedData]);  
                            // console.log('selectedData',selectedData);
                            
                            setFieldValue('factors',[selectedOption])                          
                            setFieldValue('factor',[selectedData])                          
                          }}
                          optionLabel="name"
                          optionValue="_id"
                        
                        />
                      ) : (
                              
                              <MultiSelect 
                              style={{width:"100%"}}
                               placeholder="Select factors"
                              value={typeof values.factors==='string'?[values.factors]:values.factors}
                              options={filteredDelivery?.factor||[]} 
                              onChange={(e) => {
                                const selectedOption =e.value
                                // console.log('selectedOption',e.selectedOption) 
                                setFieldValue('factors',selectedOption)                                 
                               setFieldValue('factor',filteredDelivery?.factor.length>=1?[e.selectedOption]:e.selectedOption)
                               
                              }}
                              optionLabel="name"
                              optionValue={`_id`}
                              // required={true}
                              
                              />
                      )}
                      <ErrorMessage
                        name="factor"
                        component="p"
                        className="error"
                      />
                    </FormField>

                    {/* {JSON.stringify(values)} */}

                    {/* Render input fields dynamically based on selected factors */}
                    {filteredDelivery?.factor.length? 
                    filteredDelivery?.factor?.filter((d,index)=>values.factors.includes(d._id)).map((item, i) => (
                      <FormField
                      key={i}
                      label={item.name}
                      tooltip={`Enter ${item.name} value`}
                    >
                      {/* {JSON.stringify(item)} */}
                      <TextInput
                        name={item.name}
                        type={"number"}
                        placeholder={`Enter ${item.name} value`}
                        value={values.factor[i]?.value||item.value}
                        // onChange={handleChange}
                        onChange={(e) =>{
                          // console.log("e.target.value:",e.target.value);
                          const copyFactor=[...values?.factor]    
                          item.value=e.target.value                     
                          copyFactor[i]=item
                         
                          setFieldValue(`factor`, copyFactor)
                        }}

                        required={true}
                       
                      />
                    </FormField>
                    )):''}
                  </>
                )}
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default AddDeliveryFee;
